import { render } from "./tracing.vue?vue&type=template&id=040ffcb9&scoped=true"
import script from "./tracing.vue?vue&type=script&lang=ts"
export * from "./tracing.vue?vue&type=script&lang=ts"

import "./tracing.vue?vue&type=style&index=0&id=040ffcb9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-040ffcb9"

export default script